import { fillLookupValuesByPropertyNames, getLookupDescription } from "@modernary/mui/components/lookup";
import type { EnforcementAction, EnforcementActionNew } from "./enforcementAction";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: EnforcementAction) {
  entity._authRequestFields = ["id", "complianceStatusMurn"];
  return entity;
}
function getInitialData() {
  const result = {} as EnforcementAction; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: EnforcementAction }) {
  addAuthRequestFields(response.data);

  if (response.data.inspection && !response.data.inspection?.assignedToObj) response.data.inspection.assignedToObj = {};
  if (response.data.inspection?.assignedTo) {
    response.data.inspection.assignedToObj = JSON.parse(response.data.inspection.assignedTo);
  }
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: EnforcementAction }) {
  await skinnyResponseAdapter(response);
  if (response.data.inspection) await fillLookupValuesByPropertyNames(response.data.inspection, ["typeMurn"]);

  return response.data;
}

function requestAdapter(data: EnforcementAction) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends EnforcementAction | EnforcementActionNew>(data: T) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: EnforcementAction) {}
